var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.62 31.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #805aed;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.03,0h-14.44C3.85,0,0,3.85,0,8.59v14.44c0,4.74,3.85,8.59,8.59,8.59h14.44c4.74,0,8.59-3.85,8.59-8.59v-14.44c0-4.74-3.85-8.59-8.59-8.59ZM30.67,23.03c0,4.21-3.43,7.64-7.64,7.64h-14.44c-4.21,0-7.64-3.43-7.64-7.64v-14.44C.95,4.37,4.37.95,8.59.95h14.44c4.21,0,7.64,3.43,7.64,7.64v14.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.21,5.96c-5.34,0-9.69,3.92-9.69,8.75,0,1.42.38,2.82,1.1,4.06l-1.63,3.69c-.23.53-.12,1.13.29,1.54.41.41,1.01.52,1.54.28l3.94-1.79c1.37.64,2.9.98,4.45.98,5.34,0,9.69-3.93,9.69-8.75s-4.35-8.75-9.69-8.75ZM16.21,22.45c-1.47,0-2.93-.34-4.22-.98-.14-.07-.3-.07-.44,0l-4.16,1.89c-.21.09-.35-.02-.41-.07-.05-.05-.17-.2-.08-.4l1.74-3.93c.07-.15.06-.33-.03-.47-.71-1.14-1.09-2.44-1.09-3.76,0-4.26,3.89-7.73,8.67-7.73s8.67,3.47,8.67,7.73-3.89,7.73-8.67,7.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.73,13.28c-.79,0-1.43.64-1.43,1.43s.64,1.43,1.43,1.43,1.43-.64,1.43-1.43-.64-1.43-1.43-1.43ZM11.73,15.13c-.23,0-.42-.19-.42-.42s.19-.42.42-.42.42.19.42.42-.19.42-.42.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.21,13.28c-.79,0-1.43.64-1.43,1.43s.64,1.43,1.43,1.43,1.43-.64,1.43-1.43-.64-1.43-1.43-1.43ZM16.21,15.13c-.23,0-.42-.19-.42-.42s.19-.42.42-.42.42.19.42.42-.19.42-.42.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.7,13.28c-.79,0-1.43.64-1.43,1.43s.64,1.43,1.43,1.43,1.43-.64,1.43-1.43-.64-1.43-1.43-1.43ZM20.7,15.13c-.23,0-.42-.19-.42-.42s.19-.42.42-.42.42.19.42.42-.19.42-.42.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.eb80c8173b701ade5ff6fe51d55c2314.svg";
export { ForwardRef as ReactComponent };